/**
 * Convierte un valor a formato JSON string según la especificación del API
 * @param {any} value - Valor a convertir
 * @returns {string} - JSON string válido
 */
export const valueToJsonString = (value) => {
  if (value === null || value === undefined) {
    return 'null';
  }
  // Para strings, números, booleanos, arrays y objetos, usar JSON.stringify
  return JSON.stringify(value);
};

/**
 * Convierte múltiples campos a formato de updates para PUT /sites/config/values
 * @param {Object} updates - Objeto con fieldPath como keys y valores como values
 * @returns {Object} - Objeto con valores convertidos a JSON strings
 */
export const prepareFieldUpdates = (updates) => {
  const prepared = {};
  Object.keys(updates).forEach(fieldPath => {
    prepared[fieldPath] = valueToJsonString(updates[fieldPath]);
  });
  return prepared;
};

/**
 * Obtiene el valor de un objeto usando un path
 * @param {Object} obj - Objeto
 * @param {string} path - Path (ej: "siteConfig.company.name")
 * @returns {any} - Valor encontrado
 */
export const getValueByPath = (obj, path) => {
  return path.split('.').reduce((current, key) => current?.[key], obj);
};

/**
 * Verifica si un campo es configurable
 * @param {string} fieldPath - Path del campo
 * @param {string[]} configurableFields - Lista de campos configurables
 * @returns {boolean}
 */
export const isFieldConfigurable = (fieldPath, configurableFields) => {
  if (!configurableFields || !Array.isArray(configurableFields)) {
    return false;
  }
  return configurableFields.includes(fieldPath);
};

/**
 * Verifica si un campo es fijo (no editable)
 * @param {string} fieldPath - Path del campo
 * @param {string[]} fixedFields - Lista de campos fijos
 * @returns {boolean}
 */
export const isFieldFixed = (fieldPath, fixedFields) => {
  if (!fixedFields || !Array.isArray(fixedFields)) {
    return false;
  }
  return fixedFields.includes(fieldPath);
};
